import "./style.scss";

import { formatDatesChosen } from "components/Payment";
import StatusChip from "components/shared/StatusChip";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import type { IDatesRange } from "types";

type TProps = {
    handleDownload: () => void;
    datesRange?: IDatesRange | undefined;
};

const AccountingExport = ({ handleDownload, datesRange }: TProps) => {
    const [t] = useTranslation();

    return (
        <>
            <div className="accounting-export">
                <div className="accounting-export-input">
                    <span style={{ marginBottom: "4px" }}>
                        {t("Payment.ExportAccountingText1")}
                        <StatusChip
                            status={0}
                            statusRules={{ 0: { color: "green", text: t("Filters.Paid") } }}
                            style={{ marginInline: "5px", height: "fit-content", display: "inline-block" }}
                        />
                        {t("Payment.ExportAccountingTextOr")}
                        <StatusChip
                            status={0}
                            statusRules={{ 0: { color: "orange", text: t("Filters.ForTransfer") } }}
                            style={{ marginInline: "5px", height: "fit-content", display: "inline-block" }}
                        />
                        {t("Payment.ExportAccountingText2", { dates: formatDatesChosen(datesRange, true) })}
                    </span>
                </div>
                <StyledButton buttonType="primary" fullWidth onClick={() => handleDownload()}>
                    {t("Management.YesDownload")}
                </StyledButton>
            </div>
        </>
    );
};

export default AccountingExport;
